import clsx from 'clsx'
import { ShapesIcon } from 'lucide-react'

export const SettingsEmptyState = ({
  title,
  description,
}: {
  title: string
  description: string
}) => {
  return (
    <div
      className={clsx(
        'flex h-[300px] w-full w-full flex-col items-center justify-center rounded-[12px] border-[1px] border-grey-200 bg-[#fff] pb-4 text-[13px] text-black-700',
      )}
    >
      <ShapesIcon strokeWidth={1.4} />
      <div className="flex flex-col items-center justify-center text-black-300 ">
        <div className="mb-1 mt-3  text-[15px]  font-[500]">{title}</div>
        <div className="text-grey-700 ">{description}</div>
      </div>
    </div>
  )
}
